import {
    IAppClosedTopicPayload,
    IAppCloseIntentResultTopicPayload,
    IAppInitFailedTopicPayload,
    IAppInitSucceededTopicPayload,
    IDivHostedAppInitParameters,
    IOpenAppData,
    IPerformActionTopicPayload,
    IZoidHostedAppInitParameters,
    AppIdentifiers
} from "@sparkware/uc-sdk-core";
import {ICasinofiedApplicationAdapter} from "./casinofied-application-adapter.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";

export class CasinofiedZoidApplicationAdapter implements ICasinofiedApplicationAdapter {
    constructor(protected readonly appID: AppIdentifiers,
                protected readonly applicationSdk: any,
                protected readonly services: IServiceFactoryExtended) {
    }

    init(initParams: IDivHostedAppInitParameters) {
        const clonedInitParams = {...initParams};
        delete clonedInitParams.messageBrokerChannels

        const zoidInitParams: IZoidHostedAppInitParameters = {
            ...clonedInitParams,
            onInitSucceeded: (payload) => this._onInitSucceeded(payload, initParams),
            onInitFailed: (payload) => this._onInitFailed(payload, initParams),
            openApp: payload => this._openApp(payload, initParams),
            onClose: (payload) => this._onClose(payload, initParams),
            performAction: (payload) => this._onPerformAction(payload, initParams),
            closeIntentResult: (payload) => this._onCloseIntentResult(payload, initParams),
            writeLog: (payload) => this._writeLog(payload)
        }

        this.applicationSdk.init(zoidInitParams);
    }

    focus() {
        if(this.applicationSdk.focus) {
            this.applicationSdk.focus(this.appID);
        }
    }

    dispose() {
        //nothing to do here
    }

    closeIntent(appID: string, correlationID: string): void {
        this.applicationSdk.closeIntent(appID, correlationID);
    }

    protected _openApp(payload: IOpenAppData, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.navigation.topics.openApp.publish({
                                                                               publisher: this.appID
                                                                           }, payload);
    }
    protected _onInitSucceeded(payload: IAppInitSucceededTopicPayload, initParams: IDivHostedAppInitParameters){
        initParams.messageBrokerChannels.session.topics.appInitSucceeded.publish({
            publisher: this.appID
        }, payload);
    }
    protected _onInitFailed (payload: IAppInitFailedTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.session.topics.appInitFailed.publish({
            publisher: this.appID
        }, payload)
    }
    protected _onClose(payload: IAppClosedTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.session.topics.appClosed.publish({
            publisher: this.appID
        }, payload);
    }

    protected _onPerformAction(payload: IPerformActionTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.navigation.topics.performAction.publish({
            publisher: this.appID,
        }, payload);
    }

    protected _onCloseIntentResult(payload: IAppCloseIntentResultTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.session.topics.closeIntentResult.publish({
            publisher: this.appID
        }, payload);
    }

    protected async _writeLog(payload: any): Promise<void> {
        await this.services.analytics.writeWidgetLogs(payload);
    }
}